import { usePage } from '@/hooks'
import { GxIcon } from '@garpix/garpix-web-components-react'
import React from 'react'
import { NavLink } from 'react-router-dom'
import style from '../styles/layout.module.scss'

const Navigation = ({ handleCloseHeader }): React.ReactElement => {
  const page = usePage()
  const { page_model: pageModel } = page
  const { menus } = page.init_state.global
  const { header = [] } = menus
  const handleClick = (e): void => {
    // хак из-за юнити
    if (pageModel === 'home_page') {
      e.preventDefault()
      location.href = e.currentTarget.getAttribute('href')
    } else {
      handleCloseHeader()
    }
  }
  return (
    <nav className={style.nav}>
      <ul className={style.nav_list}>
        {header.map((el) => {
          return (
            <li className={style.nav__item} key={el.id}>
              <NavLink
                to={el.property_link_value}
                onClick={handleClick}
                className={({ isActive }) =>
                  `${style.nav__link} ${isActive ? style['nav__link--active'] : ''
                  }`}
              >
                {el?.property_icon_value?.[0] !== undefined
                  ? (
                    <GxIcon src={el.property_icon_value[0]} className={style.nav__icon} />
                    )
                  : null}
                <span className={style.nav__title}>{el.name}</span>
              </NavLink>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default Navigation
